<template>
  <div class="dropdown-container position-relative"  :class="{shown: open}">
    <!-- trigger -->
    <a href="#" @click.prevent="toggleDropdown" class="dropdown-trigger">
      <slot name="trigger"></slot>
    </a>
    <div class="dropdown-items absolute bg-white py-2 mt-2 rounded shadow w-100 z-50" v-show="open">
      <slot></slot>
    </div>
  </div>
  
</template>

<script>
export default {
  name: 'dropdown',
  data () {
    return {
      open: false
    }
  },
  methods: {
    toggleDropdown (e) {
      this.open = !this.open
    },
    close (e) {
      if (!this.$el.contains(e.target)) {
        this.open = false
      }
    }
  },
  mounted () {
    document.addEventListener('click', this.close)
  },
  beforeDestroy () {
    document.removeEventListener('click',this.close)
  }
}
</script>

<style scoped>

</style>
